import herningWfs from '@/api/herningWfs';
import pointToLineDistance from '@turf/point-to-line-distance';
const OsmBaseUrl = process.env.VUE_APP_API_BASE_URL;

export async function getRuteCykelstier(ruteAsGeoJson) {
  return fetch(`${OsmBaseUrl}rpc/rute_cykelstier`, {
    method: 'POST',
    headers: _getHeaders(),
    body: JSON.stringify({
      rute_as_geojson: ruteAsGeoJson,
      rute_buffer: 1.0,
      minimum_segment_length: 20.0,
    }),
  })
    .then(response => {
      return response.json();
    })
    .catch(error => {
      throw error;
    });
}

function _getHeaders() {
  return new Headers({
    'Content-Type': 'application/json; charset=utf-8',
  });
}

export function getFarligeKrydsCloseToGeometry(geometry, distance = 20) {
  return new Promise((resolve, reject) => {
    herningWfs().then(herning => {
      const farligeKryds = herning.punkter.sortplet_kryds_2013;
      resolve(
        farligeKryds.features.filter(feature => {
          return (
            pointToLineDistance(feature.geometry.coordinates, geometry, {
              units: 'meters',
            }) < distance
          );
        })
      );
    });
  });
}
